import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [isNavExpanded, setIsNavExpanded] = useState(false);
    const token = localStorage.getItem('token');

    // Function to close the navbar
    const closeMenu = () => {
        setIsNavExpanded(false);
    };

    return (
        <nav className="navbar">
            <div className="nav-content">
                <button className="nav-toggle" aria-expanded={isNavExpanded} onClick={() => setIsNavExpanded(!isNavExpanded)}>
                    <div className="hamburger-menu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
                <div className="navbar-links">
                    <ul className={isNavExpanded ? "expanded" : ""}>
                        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                        <li><Link to="/teams" onClick={closeMenu}>Teams</Link></li>
                        {token ? (
                            <li><Link to={`/profile/${localStorage.getItem('userId')}`} onClick={closeMenu}>Profile</Link></li>
                        ) : (
                            <>
                                <li><Link to="/login" onClick={closeMenu}>Login</Link></li>
                                <li><Link to="/signup" onClick={closeMenu}>Sign Up</Link></li>
                            </>
                        )}
                    </ul>
                </div>
                <div className="RCSLogoHeaderBox">
                    <img id="RCSLogoHeader" src="\output-onlinepngtools.png" alt="RCScouting" />
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
